var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00107 20.3233V20.0386C1.04284 19.1963 1.31278 18.3802 1.78306 17.6745C2.56585 16.8267 3.10171 15.7878 3.33443 14.6668C3.33443 13.8004 3.33443 12.9216 3.4101 12.0551C3.8011 7.88394 7.92546 5 11.9994 5H12.1003C16.1742 5 20.2986 7.88394 20.7022 12.0551C20.7778 12.9216 20.7022 13.8004 20.7652 14.6668C21.0011 15.7904 21.5364 16.8325 22.3166 17.6869C22.7904 18.3864 23.0608 19.1995 23.0986 20.0386V20.3109C23.1267 21.4425 22.737 22.5459 22.0013 23.4176C21.029 24.4369 19.7097 25.0711 18.2931 25.2C14.1391 25.6456 9.94794 25.6456 5.79391 25.2C4.37889 25.0655 3.06149 24.4323 2.08577 23.4176C1.3614 22.5452 0.976913 21.4484 1.00107 20.3233Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.87158 29.5073C9.52064 30.322 10.4738 30.8492 11.5201 30.9724C12.5663 31.0955 13.6195 30.8043 14.4464 30.1633C14.7007 29.9737 14.9296 29.7533 15.1275 29.5073",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 6,
    r: 5,
    fill: "#09F5A2",
    stroke: "#191933",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/NotificationBell.292bc84b.svg";
export { ForwardRef as ReactComponent };